export default "__VITE_ASSET__42aaa3a3__"